/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Kiotviet_Link_Item_No_CodeInputs */

const vi_error_kiotviet_link_item_no_code = /** @type {(inputs: Error_Kiotviet_Link_Item_No_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng hàng này không có mã KiotViet nên không nối được.`)
};

/**

* @param {Error_Kiotviet_Link_Item_No_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_kiotviet_link_item_no_code = /** @type {((inputs?: Error_Kiotviet_Link_Item_No_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Kiotviet_Link_Item_No_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_kiotviet_link_item_no_code(inputs)
});